import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HelperFunctions } from 'src/app/util/util-functions';

@Component({
    selector: 'app-scroll-paginator',
    templateUrl: './scroll-paginator.component.html',
    styleUrls: ['./scroll-paginator.component.scss'],
    standalone: false
})
export class ScrollPaginatorComponent {

  @Input() itemsQuantity = 0;
  @Input() totalElements = 0;
  @Input() isLoading = false;
  @Input() page = 0;
  @Input() totalPages = 1;
  @Input() selector = '#main';
  @Input() fromRoot = true;
  @Input() isStatic = false;


  @Output() readonly loadPageEvent = new EventEmitter();

  /**
  * A function that checks if it is a mobile device
  * @returns {boolean}
  */
  isMobile(): boolean {
    return HelperFunctions.isMobile();
  }

  /**
  * A function that emmits the load event
  * @returns {boolean}
  */
  onLoadPage(): void {
    this.loadPageEvent.emit();
  }
}
